import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

const { TipTheme, TipLayer, TipPlacement, TipProvider } = jest.requireActual('bloko/blocks/drop/Tip/index.js');
export { TipTheme, TipLayer, TipPlacement, TipProvider };

export default mockComponentRenderProp('DropTip', null, {
    withChildren: true,
});
